"use strict";

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var abstractmessage_1 = require("./abstractmessage");

var Update =
/*#__PURE__*/
function (_abstractmessage_1$Ab) {
  _inherits(Update, _abstractmessage_1$Ab);

  function Update(token) {
    var _this;

    _classCallCheck(this, Update);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Update).call(this));
    _this.method = 'update';
    _this.token = token;
    return _this;
  }

  return Update;
}(abstractmessage_1.AbstractMessage);

exports.Update = Update;